import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type JobDetailsTabContentQueryVariables = Types.Exact<{
    jobKeys?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;

export type JobDetailsTabContentQuery = {
    __typename?: 'Query';
    jobData: {
        __typename?: 'JobDataPayload';
        results: Array<{
            __typename?: 'JobDataResult';
            job: {
                __typename?: 'Job';
                key: string;
                description: { __typename?: 'JobDescription'; html: string };
                savedJob?:
                    | { __typename?: 'SavedJob'; state: Types.SavedJobState }
                    | null
                    | undefined;
            };
        }>;
    };
};

export type JobDetailsTabContentSaveJobMutationVariables = Types.Exact<{
    input: Types.UpdateSavedJobStateInput;
}>;

export type JobDetailsTabContentSaveJobMutation = {
    __typename?: 'Mutation';
    updateSavedJobState?:
        | {
              __typename?: 'UpdateSavedJobStatePayload';
              savedJob: {
                  __typename?: 'SavedJob';
                  job: {
                      __typename?: 'Job';
                      key: string;
                      savedJob?:
                          | { __typename?: 'SavedJob'; state: Types.SavedJobState }
                          | null
                          | undefined;
                  };
              };
          }
        | null
        | undefined;
};

export const JobDetailsTabContentDocument = gql`
    query JobDetailsTabContent($jobKeys: [ID!]) {
        jobData(jobKeys: $jobKeys) {
            results {
                job {
                    key
                    description {
                        html
                    }
                    savedJob {
                        state
                    }
                }
            }
        }
    }
`;

/**
 * __useJobDetailsTabContentQuery__
 *
 * To run a query within a React component, call `useJobDetailsTabContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsTabContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDetailsTabContentQuery({
 *   variables: {
 *      jobKeys: // value for 'jobKeys'
 *   },
 * });
 */
export function useJobDetailsTabContentQuery(
    baseOptions?: Apollo.QueryHookOptions<
        JobDetailsTabContentQuery,
        JobDetailsTabContentQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<JobDetailsTabContentQuery, JobDetailsTabContentQueryVariables>(
        JobDetailsTabContentDocument,
        options,
    );
}
export function useJobDetailsTabContentLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        JobDetailsTabContentQuery,
        JobDetailsTabContentQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<JobDetailsTabContentQuery, JobDetailsTabContentQueryVariables>(
        JobDetailsTabContentDocument,
        options,
    );
}
export function useJobDetailsTabContentSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              JobDetailsTabContentQuery,
              JobDetailsTabContentQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<JobDetailsTabContentQuery, JobDetailsTabContentQueryVariables>(
        JobDetailsTabContentDocument,
        options,
    );
}
export type JobDetailsTabContentQueryHookResult = ReturnType<typeof useJobDetailsTabContentQuery>;
export type JobDetailsTabContentLazyQueryHookResult = ReturnType<
    typeof useJobDetailsTabContentLazyQuery
>;
export type JobDetailsTabContentSuspenseQueryHookResult = ReturnType<
    typeof useJobDetailsTabContentSuspenseQuery
>;
export type JobDetailsTabContentQueryResult = Apollo.QueryResult<
    JobDetailsTabContentQuery,
    JobDetailsTabContentQueryVariables
>;
export const JobDetailsTabContentSaveJobDocument = gql`
    mutation JobDetailsTabContentSaveJob($input: UpdateSavedJobStateInput!) {
        updateSavedJobState(input: $input) {
            savedJob {
                job {
                    key
                    savedJob {
                        state
                    }
                }
            }
        }
    }
`;
export type JobDetailsTabContentSaveJobMutationFn = Apollo.MutationFunction<
    JobDetailsTabContentSaveJobMutation,
    JobDetailsTabContentSaveJobMutationVariables
>;

/**
 * __useJobDetailsTabContentSaveJobMutation__
 *
 * To run a mutation, you first call `useJobDetailsTabContentSaveJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsTabContentSaveJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobDetailsTabContentSaveJobMutation, { data, loading, error }] = useJobDetailsTabContentSaveJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobDetailsTabContentSaveJobMutation(
    baseOptions?: Apollo.MutationHookOptions<
        JobDetailsTabContentSaveJobMutation,
        JobDetailsTabContentSaveJobMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        JobDetailsTabContentSaveJobMutation,
        JobDetailsTabContentSaveJobMutationVariables
    >(JobDetailsTabContentSaveJobDocument, options);
}
export type JobDetailsTabContentSaveJobMutationHookResult = ReturnType<
    typeof useJobDetailsTabContentSaveJobMutation
>;
export type JobDetailsTabContentSaveJobMutationResult =
    Apollo.MutationResult<JobDetailsTabContentSaveJobMutation>;
export type JobDetailsTabContentSaveJobMutationOptions = Apollo.BaseMutationOptions<
    JobDetailsTabContentSaveJobMutation,
    JobDetailsTabContentSaveJobMutationVariables
>;
